import React, { ChangeEvent, Component, PureComponent } from "react";
import _, { divide } from "lodash";

import {
  Theme,
  createStyles,
  WithStyles,
  withStyles,
  Typography,
  Grid,
  Button,
  TextField,
} from "@material-ui/core";
import {
  Delete as DeleteIcon,
  ReorderOutlined as ReorderIcon,
} from "@material-ui/icons";

import { statusType } from "../../types/ContentInSection";
import { MyPATExpansionPanel, MyPATMathField } from "../../../common";
import ContentFormData, {
  OptionSettingsType,
} from "../../types/ContentFormData";
import ContentFormDataError from "../../types/ContentFormDataError";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import { onlyAllowNumbers } from "../../../../utils";
import CustomInfoIcon from "../../../common/CustomInfoIcon";
import { QUESTION_TYPES } from "../../../../constants/comman";
import OptionSettings from "./OptionSettings";
import AddFeedback from '../../../content-request/components/AddFeedback';
import classNames from "classnames";
import { SECTIONS } from "../../helper/contentValidation";
import AddFeedbackPopup from "./AddFeedbackPopup";


const styles = (theme: Theme) =>
  createStyles({
    blueColor: {
      color: '#1D7DEA'
    },
    feedbackContainer: {
      position: 'relative',
      '& .feedbackBlock': {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2
      }
      },
      feedbackHighlight:{
        cursor: 'pointer',
        '&:hover':{
          color: '#1d7dea',
        }
      },
    addOptionButton: {
      marginLeft: 20,
      marginBottom: 16,
      minWidth: 90,
      height: 32,
      fontSize: 15,
    },

    borderBox: {
      background: "#FFFFFF",
      border: "1px solid #E1E1E1",
      boxSizing: "border-box",
      borderRadius: 5,
      // padding: theme.spacing.unit,
      padding: 14,
      marginBottom: "14px",
    },

    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },

    deleteVBtn: {
      border: `1px solid ${theme.palette.grey[300]}`,
      visibility: "visible",
      "& svg": {
        color: theme.palette.grey[600],
      },
    },

    deleteHBtn: {
      width: 48,
      border: "1px solid #e0e0e0",
      height: 48,
      marginLeft: 10,
      minWidth: 32,
      background: "#fff",
      "& svg": {
        color: theme.palette.grey[600],
      },
    },

    mb1x: {
      marginBottom: theme.spacing.unit,
    },

    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },

    optionColumn1: {
      paddingRight: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },

    optionIdGrid: {
      minWidth: theme.spacing.unit * 4,
      display: 'flex',
      alignItems: 'center',
      height: 45,
    },

    optionContent: {
      "& .btn-delete": {
        visibility: "hidden",
      },
      "&:hover .btn-delete": {
        visibility: "visible",
      },
      '& .jodit_workplace':{
        // borderLeft: 'none !important',
        borderTopLeftRadius: '0 !important',
        borderBottomLeftRadius: '0 !important',
        border: '1px solid #dfdfdf !important',
        maxHeight: '100%',
      },
      // '& .jodit_wysiwyg':{
      //   display: "flex",
      //   alignItems: "center",
      // },
      /* '& .jodit_placeholder':{
        top: "50%",
        transform: "translate(0%, -50%)",
      } */
    },
    optionIdTitle:{
      fontSize: '16px',
      color: '#333',
      // fontWeight: 600,
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },

    reorderBtn: {
      border: '1px solid #dfdfdf !important',
      minWidth: 55,
      padding: `0 ${theme.spacing.unit}px`,
      borderTopRightRadius: '0',
      borderBottomRightRadius: '0',
      height: '48px',
      marginBottom: 10,
      borderRight: 'none !important',
      "& svg": {
        // color: theme.palette.grey[600],
        color: '#c4c4c4',
      },
    },
    marginLeft:{
      marginLeft:'15px',
    },
    mL13:{
      marginLeft: '13px',
    },
    noPointerEvents: {
      pointerEvents: 'none'
    }
  });

const optionsIdSet: string[] = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
let sections = [
  "questionContent",
  "optionsContent",
  "correctAnswer",
  "solutionContent",
  "questionHints",
  "tags",
  "conceptCode",
];

interface ContentOptionsProps extends WithStyles<typeof styles> {
  changeHandler: Function;
  handleFormChange: Function;
  formData: ContentFormData;
  eventFired: Function;
  formDataError: ContentFormDataError;
  optionsContent: any;
  name: string;
  inputId: string;
  type: string;
  subType: string;
  error: boolean;
  errorText: string;
  optionSettings: OptionSettingsType;
  handleOptionSettingsChange: (type: string, value: any) => void;
  tag: string,
  openFeedback: boolean,
  addFeedback: Function,
  replyFeedback: Function,
  closeFeedback: Function,
  resolveFeedback: Function,
  clickedfeedbackData: any,
  addNewFeedback: Function,
  questionIndex?: number,
  selectedIndex: number,
  questionId?: string,
  authorType?: string,
  isDisable: boolean,
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
}

interface ContentOptionsState {
  options: any;
  optionData: any;
  mathEditor: any;
  displayCount: number;
  shuffleType: "same" | "random";
}

class ContentOptions extends PureComponent<
  ContentOptionsProps,
  ContentOptionsState
> {
  constructor(props: ContentOptionsProps) {
    super(props);
    this.handleCorrectOptionChange = this.handleCorrectOptionChange.bind(this);
    this.handleDeleteOptionClick = this.handleDeleteOptionClick.bind(this);
    this.setMathInstance = this.setMathInstance.bind(this);
    this.eventChanges = this.eventChanges.bind(this);
    this.handleAddOptionClick = this.handleAddOptionClick.bind(this);
  }

  draggedItem: any = {};

  componentDidMount() {
    // const self = this
    // window.onbeforeunload = function (e: any) {
    //   const { formData } = self.props
    //   self.props.handleFormChange(formData)
    //   e.preventDefault()
    //   e.returnValue = ''
    // }
  }
  checkForFeedback() {
    let { clickedfeedbackData, questionId } = this.props;
    if(this.props.selectedIndex !== undefined) {
      return (( _.isEmpty(clickedfeedbackData) && this.props.openFeedback && this.props.tag === "options" && this.props.selectedIndex === this.props.questionIndex) || (!_.isEmpty(clickedfeedbackData) && this.props.openFeedback && clickedfeedbackData.tag === "options" && questionId === clickedfeedbackData.contentId))
    } else {
      return this.props.openFeedback && this.props.tag === "options"

    }
  }
  setMathInstance = (mathEditor: any) => {
    this.setState({ mathEditor });
  };

  eventChanges(name: any) {
    if (sections.includes(name))
      this.props.eventFired(name, statusType.edit, 0, 0);
  }

  handleCorrectOptionChange = (
    optionId: string,
    evt: any,
    checked: boolean
  ) => {
    let { formData, subType } = this.props;

    if (!formData.content[0]) {
      formData.content = [{}];
    }

    if (
      formData.content[0] &&
      (!formData.content[0].correctAnswer ||
        !formData.content[0].correctAnswer.data)
    ) {
      formData.content[0].correctAnswer = {
        answerType: "id",
        data: [],
      };
    }

    //for mmcq
    if (subType == "8") {
      if (checked) {
        formData.content[0].correctAnswer.data.push({ value: optionId });
      } else {
        formData.content[0].correctAnswer.data = formData.content[0].correctAnswer.data.filter(
          (v: any) => v.value != optionId
        );
      }
    } else {
      // for smcq
      if (checked) {
        formData.content[0].correctAnswer.data = [{ value: optionId }];
      } else {
        formData.content[0].correctAnswer.data = [];
      }
    }
    // this.props.updateContent(formData)
    this.props.handleFormChange(formData);
    this.eventChanges("correctAnswer");
  };

  handleAddOptionClick() {
    let { optionsContent } = this.props;
    const optionContentCopy = JSON.parse(JSON.stringify(optionsContent));
    if(optionContentCopy.length >= 26) {
      return;
    }
    let newOptionSet = {
      id: optionsIdSet[optionsContent.length],
      value: "",
      serialNo: 1,
    };

    // if (_.isUndefined(formData.content[0])) {
    //   formData.content.push({
    //     optionsContent: [],
    //     correctAnswer: {
    //       answerType: 'id',
    //       data: [],
    //     }
    //   });
    // }
    // if (_.isUndefined(formData.content[0].optionsContent)) {
    //   formData.content[0]["optionsContent"] = [];
    // }

    // if (!_.isEmpty(formData.content[0].optionsContent)) {
    //   const optionsContent = _.get(formData.content, '[0].optionsContent', []);
    //   newOptionSet.id = optionsIdSet[optionsContent.length];
    //   newOptionSet.serialNo = optionsContent.length + 1;
    // }

    // formData.content[0].optionsContent.push(newOptionSet);
    // this.props.updateContent(formData)
    // TODO - change this format later
    optionContentCopy.push(newOptionSet);
    this.props.changeHandler(optionContentCopy);
  }

  handleDeleteOptionClick = (idx: any, id: string, evt: any) => {
    const { optionsContent, optionSettings: { displayCount } } = this.props;
    if(optionsContent.length === displayCount) {
      return;
    }
    let optionsContentCopy = JSON.parse(JSON.stringify(optionsContent));
    // let optionsContent: any[] = _.get(formData.content, '[0].optionsContent', []);
    // let correctAnswer: any[] = _.get(formData.content, '[0].correctAnswer.data', []);
    // let newOptionsContent: any[] = [];

    // // remove option from index
    // optionsContent.splice(idx, 1);

    // // reset option id and serial no
    // if (!_.isEmpty(optionsContent)) {
    //   let noId: any[] = [];

    //   optionsContent.forEach((option: any, index: number) => {
    //     option.id = optionsIdSet[index];
    //     option.serialNo = index + 1;

    //     noId.push(option.id);
    //     newOptionsContent.push(option);
    //   })

    //   correctAnswer = correctAnswer.filter((data: any) => {
    //     noId.includes(data.value);
    //   })
    // } else {
    //   correctAnswer = [];
    // }

    // formData.content[0].correctAnswer = correctAnswer;
    // formData.content[0].optionsContent = newOptionsContent;
    // this.props.updateContent(formData)
    let idIndex = 0;
    const updatedOptionsContentCopy: any = [];
    optionsContentCopy.forEach((option: any, index: number) => {
      if (index != idx) {
        option.id = optionsIdSet[idIndex];
        idIndex += 1;
        updatedOptionsContentCopy.push(option);
      }
    });
    this.props.changeHandler(updatedOptionsContentCopy);
  };

  onDragOver = (e: any, index: number) => {
    e.preventDefault();
    // let { formData, optionsContent } = this.props;
    // let optionsContentCopy: any = JSON.parse(JSON.stringify(optionsContent))
    // // let correctAnswer: any[] = _.get(formData.content, '[0].correctAnswer.data', []);

    // // let optionsContent: any[] = _.get(this.props.formData, 'content[0].optionsContent', []);
    // let newOptionsContent: any[] = [];
    // let noId: any[] = [];
    // const draggedOverItem = optionsContentCopy[index];
    // if (this.draggedItem.id === draggedOverItem.id) {
    //   return;
    // }
    // // optionsContentCopy = optionsContentCopy.filter((item: any) => item.id !== this.draggedItem.id);

    // // optionsContentCopy.splice(index, 0, this.draggedItem);
    // let draggedItemIndex = optionsContentCopy.findIndex((o: any) => o.id == this.draggedItem.id)
    // if(draggedItemIndex >= 0 && index >= 0) {
    //   let temp = optionsContentCopy[index]
    //   optionsContentCopy[index] = optionsContentCopy[draggedItemIndex]
    //   optionsContentCopy[draggedItemIndex] = temp
    // }

    // optionsContentCopy.forEach((option: any, index: number) => {
    //   let obj = {...option}
    //   obj.id = optionsIdSet[index];
    //   obj.serialNo = index + 1;

    //   noId.push(obj.id);
    //   newOptionsContent.push(obj);
    // })

    // // correctAnswer = correctAnswer.filter((data: any) => {
    // //   noId.includes(data.value);
    // // })

    // // formData.content[0].correctAnswer = correctAnswer;
    // // formData.content[0].optionsContent = newOptionsContent;
    // // this.props.updateContent(formData)
    // // this.props.handleFormChange(formData);

    // this.props.changeHandler(newOptionsContent)
  };

  onDrop(e: any, index: number) {
    e.preventDefault();
    let { formData, optionsContent } = this.props;
    let optionsContentCopy: any = JSON.parse(JSON.stringify(optionsContent));
    // let correctAnswer: any[] = _.get(formData.content, '[0].correctAnswer.data', []);

    // let optionsContent: any[] = _.get(this.props.formData, 'content[0].optionsContent', []);
    let newOptionsContent: any[] = [];
    let noId: any[] = [];
    const draggedOverItem = optionsContentCopy[index];
    if (this.draggedItem.id === draggedOverItem.id) {
      return;
    }
    // optionsContentCopy = optionsContentCopy.filter((item: any) => item.id !== this.draggedItem.id);

    // optionsContentCopy.splice(index, 0, this.draggedItem);
    let draggedItemIndex = optionsContentCopy.findIndex(
      (o: any) => o.id == this.draggedItem.id
    );
    if (draggedItemIndex >= 0 && index >= 0) {
      let temp = optionsContentCopy[index];
      optionsContentCopy[index] = optionsContentCopy[draggedItemIndex];
      optionsContentCopy[draggedItemIndex] = temp;
    }

    optionsContentCopy.forEach((option: any, index: number) => {
      let obj = { ...option };
      obj.id = optionsIdSet[index];
      obj.serialNo = index + 1;

      noId.push(obj.id);
      newOptionsContent.push(obj);
    });

    // correctAnswer = correctAnswer.filter((data: any) => {
    //   noId.includes(data.value);
    // })

    // formData.content[0].correctAnswer = correctAnswer;
    // formData.content[0].optionsContent = newOptionsContent;
    // this.props.updateContent(formData)
    // this.props.handleFormChange(formData);

    this.props.changeHandler(newOptionsContent);
  }

  onDragEnd = () => {
    this.draggedItem = {};
  };

  handleOptionValueChange(index: any, evt: any) {
    const { optionsContent } = this.props;
    const optionsContentCopy: any = JSON.parse(JSON.stringify(optionsContent));
    // let optionData = this.state.optionData;
    // optionData[index] = evt.target.value
    // this.setState({
    //   optionData: optionData
    // })
    //console.log(this.state.optionData);
    //formData.content[0].optionsContent[index].value = evt.target.value;
    // this.props.updateContent(formData)
    for (let step = 0; step < optionsContentCopy.length; step++) {
      optionsContentCopy[index].value = evt.target.value;
    }
    // TODO - fix this format later
    this.props.changeHandler(optionsContentCopy);
    //this.eventChanges("optionsContent");
  }

  onDragStart = (evt: any, index: number) => {
    const { optionsContent } = this.props;
    const optionsContentCopy: any = JSON.parse(JSON.stringify(optionsContent));
    // const optionsContent: any[] = _.get(this.props.formData, 'content[0].optionsContent', []);
    this.draggedItem = optionsContentCopy[index];
    evt.dataTransfer.effectAllowed = "move";
    evt.dataTransfer.setData("text/html", evt.target.parentNode);
    evt.dataTransfer.setDragImage(evt.target.parentNode, 20, 20);
  };

  handleOptionSettings = (type: string, value: any) => {
    this.props.handleOptionSettingsChange(type, value);
    if(type === 'displayCount' && value !== '') {
      const noOfOptionsDiff = value - this.props.optionsContent.length
      console.log(noOfOptionsDiff)
      if(noOfOptionsDiff > 0) {
        for(let i=0;i<noOfOptionsDiff;i++) {
          setTimeout(() => {
            this.handleAddOptionClick();
          }, 0);
        }
      }
    }
  }

  render() {
    const {
      classes,
      optionsContent,
      error,
      errorText,
      subType,
      formDataError,
      optionSettings,
      questionIndex,
      isDisable,
      activeValidationFeedbackSection,
      activeValidationFeedbackData,
      handleAddCommentInFeedback,
      createNewValidationFeedback,
    } = this.props;
    let options = optionsContent;

    return (
      <>
        {// if smcq and mmcq
        ["0", "8", "2"].includes(subType) && (
          <MyPATExpansionPanel
            isDisable={isDisable}
            hasExpandIcon
            // defaultExpanded={false}
            sectionId="optionsContent" // used for scrolling to this section
            variant="white"
            customCollapseTitle={
              <Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
                event.stopPropagation();
                this.props.addFeedback('options', questionIndex)}}>

<span 
            id={this.checkForFeedback() ? 'feedbackScroll' : ''}
            className={`${classes.feedbackContainer} ${this.checkForFeedback() ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}>
              Options<span className={classes.requiredHeading}>*  </span>
              {this.checkForFeedback() && (
                <Grid className="feedbackBlock">
                   <AddFeedback 
                   author={this.props.authorType}
                   replyFeedback={this.props.replyFeedback} closeFeedback={this.props.closeFeedback} resolveFeedback={this.props.resolveFeedback} clickedfeedbackData={this.props.clickedfeedbackData} addNewFeedback={this.props.addNewFeedback} />
              </Grid>)}
                {
                  activeValidationFeedbackSection === SECTIONS.OPTIONS && (
                    <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                  )
                }
              </span>
              <CustomInfoIcon
                infoDialogContentType="Goal Management"
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Options"
                imageURL="/assets/svg/infoIcon/options.svg"
                dialogPara="Add options by entering text, pasting an image, or using the formatting toolbar at the top <br/><br/>
                Click on the Icon <img src='/assets/svg/infoIcon/sequence.svg'/> and drag the selections for resequencing as per your preferences <br/><br/>
                You can also remove any option by clicking the Delete button that appears when you hover over it"
                details="Click to know more"
                toolTipDirection="top" />
              </Typography>
            }
            error={error}
            errorText={errorText}
          >
            <OptionSettings
              subType={subType}
              handleOptionSettingsChange={this.handleOptionSettings}
              optionSettings={optionSettings}
              tag={this.props.tag}
              openFeedback={this.props.openFeedback}
              addFeedback={this.props.addFeedback}
              replyFeedback={this.props.replyFeedback} 
              closeFeedback={this.props.closeFeedback} 
              resolveFeedback={this.props.resolveFeedback}
              clickedfeedbackData={this.props.clickedfeedbackData}
              addNewFeedback={this.props.addNewFeedback}
              authorType={this.props.authorType}
            />
            <div className={classes.borderBox}>
              <Grid container className={classes.mb1x}>
                <Grid item xs={12} className={classes.optionColumn1}>
                  <Typography variant="subtitle1" className={classes.mb2x}>
                    Define Option List
                  </Typography>

                  {_.map(options, (option, index: number) => (
                    <Grid
                      container
                      key={option.id + index}
                      spacing={8}
                      justify="space-between"
                      alignItems="center"
                      onDragOver={(e) => this.onDragOver(e, index)}
                      onDrop={(e) => this.onDrop(e, index)}
                      className={classNames(classes.optionContent, subType === QUESTION_TYPES.TRUE_FALSE.toString() && classes.noPointerEvents)}
                    >
                      <Grid item xs={12}>
                        <MyPATMathField
                          gridSize={9}
                          editorProps={{
                            externalToolbarId: "box",
                            name: "optionsContent",
                            value: option.value,
                            editorId: `editor_${option.id}`,
                            handleChange: this.handleOptionValueChange.bind(
                              this,
                              index
                            ),
                            setInstance: this.setMathInstance,
                            placeholder: `Add option ${index+1} (Enter Option Text or Paste Image)`
                          }}
                          startAdorment={
                            <Grid item xs="auto">
                              <Grid container>
                                <Grid
                                  item
                                  xs="auto"
                                  className={classes.optionIdGrid}
                                >
                                  <Typography variant="subtitle1" noWrap className={classes.optionIdTitle}>
                                    {option.id}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs="auto"
                                  draggable
                                  onDragStart={(e) =>
                                    this.onDragStart(e, index)
                                  }
                                  onDragEnd={this.onDragEnd}
                                >
                                  <Button
                                    variant="outlined"
                                    className={classes.reorderBtn}
                                    disabled
                                  >
                                    <ReorderIcon />
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          }
                          endAdorment={
                            <Grid item xs={1}>
                              {subType != "2" && (
                                <Grid item xs="auto">
                                  <Button
                                    variant="outlined"
                                    className={
                                      classes.deleteHBtn + "  btn-delete"
                                    }
                                    disabled={this.props.optionsContent === this.props.optionSettings.displayCount}
                                    onClick={this.handleDeleteOptionClick.bind(
                                      this,
                                      index,
                                      option.id
                                    )}
                                  >
                                    <img src="/assets/svg/myLibrary/delete-outline.svg" />
                                    {/* <DeleteIcon /> */}
                                  </Button>
                                </Grid>
                              )}
                            </Grid>
                          }
                        />
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid className={classes.mL13}>
              {subType != "2" && (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  className={classes.addOptionButton}
                  onClick={this.handleAddOptionClick.bind(this)}
                  z-index={9999}
                >
                  + Add
                </Button>
              )}
              </Grid>
            </div>
          </MyPATExpansionPanel>
        )}
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(ContentOptions);
